import React, { useState, useEffect, useRef } from 'react';
import { DropdownButton, Glyphicon, MenuItem } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { handleKeyPress, handleClickOutside } from './helpers';
import { uuid } from '../../../utils/helper';

const MultiSelect = ({ id, options, title, values, onChange }) => {
  const ref = useRef();

  const [open, setOpen] = useState(false);
  const toggle = () => setOpen((prev) => !prev);

  const keyHandler = (e) => handleKeyPress(e, setOpen);
  const clickHandler = (e) => handleClickOutside(e, setOpen, ref);

  const onChangeSelect = (newValue) => {
    if (newValue === null) return;
    if (onChange) {
      const numId = Number(newValue);
      const filteredState = values.filter((item) => Number(item) !== numId);
      const hadElements = values.some((item) => Number(item) === numId);

      onChange(hadElements ? filteredState : [...filteredState, newValue])
    }
  }

  useEffect(() => {
    if (open) {
      document.addEventListener('click', clickHandler);
      document.addEventListener('keydown', keyHandler);
    }
    return () => {
      document.removeEventListener('click', clickHandler);
      document.removeEventListener('keydown', keyHandler);
    };
  }, [open]);

  return (
    <div ref={ref}>
      <DropdownButton
        title={title}
        onToggle={() => {}}
        onClick={toggle}
        open={open}
        id={id}
      >
        {options.map((item, index) => (
          <MenuItem onClick={() => onChangeSelect(item.value)} className="select__menu-item select__menu-item-multi" key={index}>
            <span className="text">{item.label}</span>

            {values.includes(item.value) ? <Glyphicon className="select__selected-glyph" glyph="ok" /> : null}
          </MenuItem>
        ))}
      </DropdownButton>
    </div>
  );
};

MultiSelect.propTypes = {
  onChange: PropTypes.func,
  options: PropTypes.array,
  values: PropTypes.array,
  title: PropTypes.string,
  id: PropTypes.any,
};

MultiSelect.defaultProps = {
  options: [],
  values: [],
  title: 'Options',
  id: uuid(),
};

export default MultiSelect;
